import { callApiToServer } from '../callApi';

export async function listCardReport(
  authtoken,
  startDate,
  endDate,
  city // optional city parameter
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
      
    let body = JSON.stringify({
        startDate : startDate,
        endDate : endDate,
        ...(city && { city }) // Add city if it’s defined
    });

    let endUrl = "v1/auth/list-card-report";
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
      
  }catch(err) {
    throw err;
  }
}
